<template>
  <div class="help-modal">
    <b-modal
      hide-header
      lazy
      no-fade
      ok-only
      v-model="help.alert.shown"
      @ok="handleOk"
    >
      <div v-if="help.alert.text === help.alert.SURVEY_WELCOME">
        Welcome to the survey!
      </div>
    </b-modal>
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue';
import Help from '@/providers/Help.js';

export default Vue.extend({
  name: 'helpAlertModal',
  data() {
    return {
      help: Help,
    };
  },
  methods: {
    handleOk: function () {
      this.help.alert.ok();
    },
  },
});
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss"></style>
